<template>
  <div className="d-flex justify-content-between align-items-center " v-if="load">
    <div class="pay-loading">
      <lottie :options="defaultOptions" :height="400"  style="width: 250px" />
    </div>
  </div>
</template>
<script>
  import { bus } from '../main'
  import Lottie from '../Lottie.vue'
  import * as animationData from '../assets/loading.json'

  export default {
    name: 'app',
    components: {
      lottie : Lottie

    },
    data () {
      return {
        load: false,
        defaultOptions: { animationData: animationData.default },
        animationSpeed: 1
      }
    },
    methods: {},
    mounted () {
      bus.$on('show_spinner', (name) => {
        // console.log('bus', name)
        if (name === 'true') {
          this.load = true
        } else {
          this.load = false
        }
        // setTimeout(this.load = name , 1000)
      })
    }
  }
</script>
<style>
  .pay-loading {
    position: fixed;
    background: #80808075;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    max-height: 100%;
    height: 100%;
    z-index: 11;
    padding-top: 40%;
    text-align: center;
  .spinner-border {
    width: 4rem;
    height: 4rem;
    border: 0.25em solid #3c8dbc;
    border-right-color: #17495f;
  }
  }
</style>
